<script>
  import { onMount } from "svelte";
  import { calcPercent, makeWebsiteRequest } from "../Common/tools";
  import Table from "../Table/Table.svelte";
  import MarketingLimitsWarning from "../Common/MarketingLimitsWarning.svelte";
  import NewAutomationPopup from "../Automation/Popups/NewAutomationPopup.svelte";
  import { saveAutomation } from "../Automation/Index.svelte";
  import {External, M} from "../external";

  let tab = "all",
    query = "",
    selection = null,
    loading = false;
  let moreInstance;
  let active = false;
  let data = { draft: false };

  let helpVideoMarkup = "";

  let currentPage = 1;
  let pagesCount = 0;
  let itemsPerPage = 0;

  onMount(() => {
    readAutomations(0, false);
    if (External.Website.onboarding && External.Website.onboarding.marketingAutomations) {
      helpVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.marketingAutomations);
    }
  });

  data = {
    count: 0,
    columns: [
      {
        key: "visualStatus",
        type: "image",
        label: "",
        class: "mw-72",
        rowClassConditions: [" stop ", " autorenew "],
        rowClasses: ["material-icons circle-automation-icon red-border", "material-icons-outlined circle-automation-icon"]
      },
      {
        key: "name",
        label: M.NAME,
        class: "flex-1 mw-300 ws-normal",
        row: "formattedModified",
        rowLabel: M.CREATED_AT,
        tags: [{ key: "draft", label: M.DRAFT }]
      },
      { key: "total", label: M.AUDIENCE, class: "mw-100" },
      // {key: 'waiting', label: 'Waiting', rowClass: 'order-status pending', class: 'mw-100'},
      // {key: 'completed', label: 'Completed', rowClass: 'pay-status paid', class: 'mw-100'},
      { key: "open", label: M.OPENED, rowClass: "order-status pending", class: "mw-100" },
      { key: "click", label: M.CLICKED, rowClass: "pay-status paid", class: "mw-100" },
      {
        key: "goalReached",
        label: M.GOAL,
        rowClass: "pay-status paid",
        class: "mw-100",
        rowClassConditions: [M.NO_GOAL_SET],
        rowClasses: ["order-status pending", "pay-status paid"]
      },
      {
        type: "action",
        action: (id, action, row) => {
          if (action === "activate") {
            if (row.draft && !row.flow) {
              External.Tools.showError(M.TRIGGER_WARNING);
              return;
            }
            /* allowing no-trigger active automations for now
            else if (row.draft && (!row.flow.start || !row.flow.start.triggers || row.flow.start.triggers.length === 0)) {
              External.Tools.showError(M.TRIGGER_WARNING2);
              return;
            }
           */
            else if (row.draft && (!row.flow.steps || row.flow.steps.length === 0)) {
              External.Tools.showError(M.TRIGGER_WARNING3);
              return;
            } else {
              let state = row.draft == null || row.draft == 1;
              let message = state ? M.TURN_ON_AUTOMATION : M.TURN_OFF_AUTOMATION;

              External.Tools.prompt(M.TURN_ON_AUTOMATION, message, async () => {
                let newData = {
                  id: id,
                  name: row.name,
                  flow: row.flow,
                  draft: !state
                };

                let result = await saveAutomation(newData);
                row.draft = result.draft;
                readAutomations(0, false);
              });
            }
          } else if (action === "delete") {
            External.Tools.prompt(M.DELETE, M.DELETE_AUTOMATION, () => {
              External.Tools.makeWebsiteRequest({
                action: "deleteAutomation",
                data: {
                  id: id
                },
                onOk: () => {
                  readAutomations(0, false);
                }
              });
            });
          } else if (action === "rename") {
            External.Tools.promptForInput(M.RENAME, M.INSERT_AUTOMATION_NAME, row.name, async (input) => {
              let newData = {
                id: id,
                name: input,
                flow: row.flow,
                draft: row.draft
              };

              let result = saveAutomation(newData);
              row.draft = result.draft;
              readAutomations(0, false);
            });
          } else if (action === "clone") {
            External.Tools.prompt(M.CLONE_AUTOMATION, M.ARE_YOU_SURE_CLONE_AUTOMATION, () => {
              External.Tools.makeWebsiteRequest({
                action: "cloneAutomation",
                data: {
                  id: id
                },
                onOk: () => {
                  readAutomations(0, false);
                }
              });
            });
          }
        },
        items: [
          { text: M.ONOFF, icon: "fa-toggle-on", tag: "activate" },
          { text: M.RENAME, icon: "fa-edit", tag: "rename" },
          { text: M.CLONE, icon: "fa-copy", tag: "clone" },
          { text: M.DELETE_TITLE, icon: "fa-trash", tag: "delete" }
        ],
        class: "mw-40"
      }
    ],
    rows: []
  };

  let switchTab = (t) => {
    selection = null;
    tab = t;
    data.rows = [];
    readAutomations(0, false);
  };

  async function readAutomations(page, append) {
    if (loading) return;
    loading = true;

    let request = {
      skip: page * itemsPerPage,
      withStats: true
    };

    let filters = {};

    if (tab === "drafts") {
      filters.draft = true;
    } else if (tab === "active") {
      filters.draft = false;
    }

    if (query !== "") {
      filters.name = query;
    }

    if (Object.keys(filters).length > 0) {
      request.filters = JSON.stringify(filters);
    }

    let response = await makeWebsiteRequest({
      action: "getAutomations",
      data: request
    });

    loading = false;
    if (!response.data) {
      loading = false;
      return;
    }

    data.count = response.data.count;
    pagesCount = response.data.pagesCount;
    itemsPerPage = response.data.itemsPerPage;
    currentPage = page;

    let items = response.data.items;
    items.forEach((item) => {
      item.total = item.completed + item.waiting;
      item.visualStatus = item.draft == null || item.draft == 1 ? " stop " : " autorenew ";
      item.formattedModified = item.modified ? External.Tools.dateToString(new Date(item.modified.epochSecond * 1000), true, true) : "";
      item.goalReached =
        !item.flow || !item.flow.goals || item.flow.goals.length == 0 ? M.NO_GOAL_SET : "" + item.goalReached + " (" + calcPercent(item.goalReached, item.total) + ")";
      item.open = calcPercent(item.opened, item.sent);
      item.click = calcPercent(item.clicked, item.sent);
    });

    if (append) {
      data.rows = data.rows.concat(items);
    } else {
      data = Object.assign({}, data, { rows: items });
    }

    loading = false;
  }

  let createNewAutomation = (templateId) => {
    External.Tools.promptForInput(M.ADD_AUTOMATION, M.INSERT_AUTOMATION_NAME, async (input) => {
      let response = await makeWebsiteRequest({
        action: "createNewAutomation",
        data: {
          name: input,
          template: templateId
        }
      });
      CPanel.goToUrl("/me/crm/marketing/automation?id=" + response.data.id, true);
    });
  };

  let onCreateAutomationBtnClick = (event) => {
    let existingAutomations = data.rows || [];
    let hasAbandonedCartAutomation =
      existingAutomations.filter((automation) => {
        if (automation.flow && automation.flow.start && automation.flow.start.triggers) {
          return automation.flow.start.triggers.filter((trigger) => trigger.type === "CART_ABANDON").length > 0;
        }
        return false;
      }).length > 0;

    if (hasAbandonedCartAutomation) {
      createNewAutomation(-1);
    } else {
      Tools.showWindow({
        width: 645,
        customClass: "add-automation-dialog",
        isModal: false,
        noTitle: true,
        noNav: true,
        withDarkBackground: true,
        forceAtRight: false,
        action: {
          onShow: function (popup, context) {
            popup.bindComponent(
              new NewAutomationPopup({
                target: popup.getContentArea(),
                props: {
                  onOptionSelected: (templateId) => {
                    popup.close();
                    createNewAutomation(templateId);
                  }
                }
              })
            );
          }
        }
      });
    }
  };

  let click = (row) => {
    External.CPanel.goToUrl("/me/crm/marketing/automation?id=" + row.id, true);
  };

  let onQuery = () => {
    search();
  };

  let search = External.$.debounce(250, () => {
    readAutomations(0, false);
  });

  let onMoreClick = () => {
    const target = External.$(moreInstance);
    const items = [{ text: M.DELETE_SELECTED, icon: "fa-trash", tag: "delete" }];

    External.Tools.showTooltipOptions(target, items, (target, idx, text, tag) => {
      if (tag === "delete") {
        if (!selection || (!selection.all && (!selection.hasOwnProperty("selected") || selection.selected.length === 0))) {
          External.Tools.showError(M.SELECT_AUTOMATION_FIRST);
          return;
        }

        External.Tools.prompt(M.DELETE, M.AUTOMATION_DELETE_QST, () => {
          External.Tools.makeWebsiteRequest({
            action: "deleteAutomations",
            data: {
              selection: JSON.stringify(selection)
            },
            onOk: () => {
              readAutomations(0, false);
            }
          });
        });
      }
    });
  };

  const nextPage = () => {
    if (loading) return;
    if (data.count === null || currentPage + 1 >= pagesCount) return;
    readAutomations(currentPage + 1, true);
  };
</script>

<div class="flex flex-row-col-responsive flex-col">
  <div class="account-settings store-products flex-1 horizontal-flex-table col20" style="font-family: 'Roboto';">
    <div class="top-background-wrapper wide-top-background" style="padding-top:30px;">
      <div class="top-background" style="max-width:1200px;">
        <div class="text-wrapper f-left col20 flex align-center space-between mobile-row">
          <div class="flex align-center">
            <div class="flex flex-start flex-col f-left mr-20">
              <h2 class="crm-title crm-title-bigger f-left">
                {M.ALL_AUTOMATIONS}
              </h2>
              <h2 class="crm-title f-left mt-5" style="opacity: .7;">{data.count} {M.AUTOMATIONS}</h2>
            </div>
            <div class="f-right flex-centered">
              <a class="crm-option" style="padding-right: 33px;" on:click={onMoreClick} bind:this={moreInstance}>
                {M.MORE}
                <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
                  <path d="M4 6l4 4 4-4H4z" />
                </svg>
              </a>
            </div>
          </div>
          <div>
            <a on:click={(e) => onCreateAutomationBtnClick(e)} class="f-right middle-button blue with-icon" style="height:42px; line-height:42px;">
              {M.CREATE_AUTOMATION}
            </a>
            <div class="col5 f-right mr-10 search-outer-wrapper">
              <input type="text" bind:value={query} on:keyup={onQuery} class="search-input border-type-all" placeholder={M.SEARCH_IN_AUTOMATIONS} />
              <span class="material-icons"> search </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-wrapper horizontal-flex-table" style="max-width:1200px; width: 94%;">
      <div class="sections-wrapper members-wrapper horizontal-flex-table">
        <div class="section-bg members-wrapper products-wrapper crm-table-outer">
          <ul class="upper-navigation upper-navigation-full mb-15 mt-15">
            <li><a on:click={() => switchTab("all")} class:active={tab === "all"}>{M.ALL_AUTOMATIONS}</a></li>
            <li><a on:click={() => switchTab("active")} class:active={tab === "active"}>{M.ACTIVE}</a></li>
            <li><a on:click={() => switchTab("drafts")} class:active={tab === "drafts"}>{M.DRAFTS}</a></li>
          </ul>

          <MarketingLimitsWarning />

          {#if loading || data.rows.length}
            <Table activeColumns={data.columns} bind:data={data.rows} bind:selection onClick={click} loading={loading} nextPage={nextPage} />
          {:else if tab === "all"}
            <div class="col20 f-left getting-started-layout flex">
              <div class="col11 f-left">
                <h4 class="col20 f-left"><span>{M.AUTOMATIONS}</span></h4>
                <h1 class="col20 f-left mt-10 mb-15">{M.CREATE_AUTOMATION_FLOWS}</h1>
                <span class="col20 f-left paragraph-text mb-25">
                  {M.CREATE_AUTOMATION_FLOWS_DESC}
                </span>
                <div class="col20 f-left">
                  <a on:click={(e) => onCreateAutomationBtnClick(e)} class="blue big-button with-icon">{M.CREATE_AUTOMATION}</a>
                </div>
              </div>
              <div class="col9 f-left justify-center align-center flex">
                {#if helpVideoMarkup}
                  <div class="col20 f-left">
                    {@html helpVideoMarkup}
                  </div>
                {:else}
                  <img src={External.staticResource("/images/automation-image.png")} alt="" />
                {/if}
              </div>
            </div>
          {:else}
            <div class="text-center col20 f-left" style="padding: 50px 30px 70px 30px; box-sizing: border-box;">
              <h4 class="col20 f-left t-center mb-15">{M.NO_AUTOMATIONS_YET}</h4>
              <div class="col20 f-left t-center">
                <a class="middle-button blue with-icon inline-block f-none" on:click={(e) => onCreateAutomationBtnClick(e)}>
                  {M.CREATE_AUTOMATION}
                </a>
              </div>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
